import React from 'react'
import { ReactComponent as DragAndDrop } from 'components/CRM/UI/icons/drag-drop-line.svg'
import styles from './LeadCard.module.scss'
import { dateFormat } from 'helpers/date'
import Button from 'components/CRM/UI/components/Button/Button'

export const LeadCard = ({
  client,
  status_lead_id,
  statusLeads,
  comment,
  lead_name,
  created_at,
  details,
  openModal,
  addDeal,
  session_id,
}) => {
  const status = statusLeads.find((status) => status.id === status_lead_id)

  const truncateText = (text, maxLength = 40) => {
    if (text && text.length > maxLength) {
      return text.substring(0, maxLength) + '...'
    }
    return text
  }

  const buttonState = () => {
    const isPosition1 = status.position === 1
    const isPosition3 = status.position === 3
    const sessionId = session_id === null
    const withoutPhone = client.phone === null || ''
    return (
      <div className={styles.typeLeadAndBtn}>
        <button
          disabled={isPosition1}
          onClick={details}
          className={`${styles.btn}`}
        >
          Details
        </button>
        <button
          disabled={isPosition1 || isPosition3 || withoutPhone || sessionId}
          onClick={openModal}
          className={`${styles.btn}`}
        >
          Chat
        </button>
        <Button
          isDisabled={isPosition1}
          onClick={addDeal}
          text={'Create a deal'}
          withIcon
        />
      </div>
    )
  }

  return (
    <div className={styles.leadCardContainer}>
      <div className={styles.leadInfoBlock}>
        <div className={styles.leadClientName}>{client.name}</div>
        <div className={styles.typeLeadStatusInfo}>
          <div
            className={styles.typeStatus}
            style={{ backgroundColor: status.color.body_color }}
          >
            <span
              className={styles.typeStatusCircle}
              style={{ backgroundColor: status.color.background_color }}
            ></span>
            <span style={{ color: status.color.background_color }}>
              {status.name}
            </span>
          </div>
          <div>
            <DragAndDrop />
          </div>
        </div>
      </div>
      <div className={styles.typeLeadColumn}>
        <div>
          <div className={`${styles.leadNumber} ${styles.typeLeadInfo}`}>
            <span>Lead number:</span>
            <span>{lead_name}</span>
          </div>
          <div className={`${styles.typeLeadInfo}`}>
            <span>Telephone:</span>
            <span> {client.phone}</span>
          </div>
          <div className={`${styles.typeLeadInfo}`}>
            <span>Date of creation:</span>
            <span>{dateFormat(created_at, 'dd.mm.YY')}</span>
          </div>
          <div className={`${styles.typeLeadInfo}`}>
            <span>A comment:</span>
            <span>{truncateText(comment)}</span>
          </div>
        </div>
      </div>
      <div className={styles.typeLeadAndDateBlock}>{buttonState()}</div>
    </div>
  )
}
